import { Box, Modal } from "@mui/material";
import { BackendConfigField, Tier } from "../../../types/types"
import { Button } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

export interface BackendConfigModalProps {
    field: BackendConfigField | undefined,
    open: boolean,
    cancel: Function,
    submit: Function
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    maxWidth: '75%',
    minWidth: '25%',
    height: 'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflow: 'hidden',
    p: 4,
};

function BackendConfigModal(props: BackendConfigModalProps) {

    const formRef = useRef(null)
    const [name, setName] = useState("")
    const [value, setValue] = useState("")

    useEffect(() => {
        if (!props.open) {
            setName("")
            setValue("")
            return;
        }

        if (!props.field) return;

        setName(props.field.name)
        setValue(props.field.value)
    }, [props.open])

    const onSubmit = (event: any) => {
        event.preventDefault();
        const cronRegex = new RegExp(/^(((\*)|(\*\/\d+)|(\d+)) ){4}(((\*)|(\*\/\d+)|(\d+)))$/)
        if (name.toLowerCase().includes("cronstring")) {
            if (!cronRegex.test(value)) {
                toast.error("You seem to be adding a cron with an invalid Format. Following the Format of * * * * * with minute, hour, dayOfMonth, month, dayOfWeek")
                return;
            }
        }
        props.submit(name, value)
    }

    return (
        <div>
            <Modal
                open={props.open}
                onClose={() => {props.cancel()}}
            >
                <Box sx={style}>
                    <div>
                        <form ref={formRef} onSubmit={onSubmit}>
                            <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                                <div className="textFieldDiv">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        placeholder="Name"
                                        value={name}
                                        required={true}
                                        onChange={(e) => {setName(e.target.value)}}
                                    />
                                </div>
                                <div className="textFieldDiv">
                                    <label>Value</label>
                                    <input
                                        type="text"
                                        placeholder="Name"
                                        value={value}
                                        required={true}
                                        onChange={(e) => {setValue(e.target.value)}}
                                    />
                                </div>
                                <div>
                                    <Button style={{marginRight: '10px'}} onClick={() => {props.cancel()}}>Cancel</Button>
                                    <Button type='submit'>Save</Button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default BackendConfigModal